module.exports = __webpack_public_path__ + "img/ex-flash.5235e158.jpg";